import { useState } from "react";

const validateRequired = {
  check: (value) => !value,
  message: "Value is required",
};
const validateMinimumCharacters = (minimumCharacters) => ({
  check: (value) => value?.length < minimumCharacters,
  message: `Minimum ${minimumCharacters} Characters is required`,
});
const validateMaximumCharacters = {
  check: (value) => value?.length > 1000,
  message: "A Maximum 1000 Characters is allowed",
};

const validateMinimum20Characters = validateMinimumCharacters(20);
const validateMinimum100Characters = validateMinimumCharacters(100);

const validators = {
  voiceDescription: [
    validateRequired,
    validateMinimum20Characters,
    validateMaximumCharacters,
  ],
  text: [validateMinimum100Characters, validateMaximumCharacters],
};

function validate(field, value) {
  return validators[field].find((rule) => rule.check(value))?.message ?? null;
}

export default function usePromptVoiceState() {
  const [promptVoiceState, setPromptVoiceState] = useState({
    voiceDescription: "",
    text: "",
    errors: {
      voiceDescription: null,
      text: null,
    },
  });

  function updateField(key, value) {
    setPromptVoiceState((prevState) => {
      return {
        ...prevState,
        [key]: value,
        errors: {
          ...prevState.errors,
          [key]: prevState.errors[key] && null
        },
      };
    });
  }

  function updateVoiceDescription(value) {
    updateField("voiceDescription", value);
  }

  function updateText(value) {
    updateField("text", value);
  }

  function validatePromptVoiceState() {
    const voiceDescriptionError = validate(
      "voiceDescription",
      promptVoiceState.voiceDescription
    );
    const textError = promptVoiceState.text.trim()
      ? validate("text", promptVoiceState.text)
      : null;

    if (voiceDescriptionError || textError) {
      setPromptVoiceState((prevState) => {
        return {
          ...prevState,
          errors: {
            voiceDescription: voiceDescriptionError,
            text: textError,
          },
        };
      });

      return false;
    }

    return true;
  }

  return {
    promptVoiceState,
    updateVoiceDescription,
    updateText,
    validatePromptVoiceState,
  };
}
